import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError, toastSuccess } from './other.slice';
import axios from 'axios';

const initialState = {
    verified: 0,
    pending: 0,
    users: [],
    total: 0,
    pages: 0,
    current: 0,
    profile: {},
    error: null,
    loading: false,
    sloading: false,
}

export const profilesReq = createAsyncThunk('profilesReq', async ({ page, country, text, status }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/profiles/${status}?page=${page}&text=${text}&country=${country}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const singleProfilesReq = createAsyncThunk('singleProfilesReq', async ({ id }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/verification/profile/${id}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const verifyProfilesReq = createAsyncThunk('verifyProfilesReq', async ({ id, role, status }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/user/verifiy/${id}/${role}`, { status },
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const unVerifyProfilesReq = createAsyncThunk('unVerifyProfilesReq', async ({ id, role, data }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.put(`${BASEURL}/admin/user/unverifiy/${id}/${role}`, data,
            { headers: headers() })
            .then((res) => {
                if (res?.data?.success) {
                    dispatch(toastSuccess(res?.data?.message))
                }
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const ProfilesSlice = createSlice({
    name: 'profilesSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(profilesReq.pending, (state, action) => {
            state.loading = true
            state.pages = 0
            state.total = 0
            state.current = 0
            state.pending = 0
            state.verified = 0
            return state
        })
        builder.addCase(profilesReq.fulfilled, (state, action) => {
            state.loading = false
            state.users = action.payload.data?.users
            state.pages = action.payload.data?.pages
            state.total = action.payload.data?.total
            state.pending = action.payload.data?.pending
            state.verified = action.payload.data?.verified
            state.current = action.payload.data?.current
            return state
        })
        builder.addCase(profilesReq.rejected, (state, action) => {
            state.pages = 0
            state.total = 0
            state.current = 0
            state.pending = 0
            state.verified = 0
            state.loading = false
            state.error = 'Error occured'
            return state
        })

        builder.addCase(singleProfilesReq.pending, (state, action) => {
            state.loading = true
            state.profile = {}
            return state
        })
        builder.addCase(singleProfilesReq.fulfilled, (state, action) => {
            state.loading = false
            state.profile = action.payload.mdata
            return state
        })
        builder.addCase(singleProfilesReq.rejected, (state, action) => {
            state.loading = false
            state.profile = {}
            state.error = 'Error occured'
            return state
        })

        builder.addCase(verifyProfilesReq.pending, (state, action) => {
            state.sloading = true
            return state
        })
        builder.addCase(verifyProfilesReq.fulfilled, (state, action) => {
            state.sloading = false
            state.profile = action.payload.data
            return state
        })
        builder.addCase(verifyProfilesReq.rejected, (state, action) => {
            state.sloading = false
            state.error = 'Error occured'
            return state
        })

        builder.addCase(unVerifyProfilesReq.pending, (state, action) => {
            return state
        })
        builder.addCase(unVerifyProfilesReq.fulfilled, (state, action) => {
            state.profile = action.payload.data
            return state
        })
        builder.addCase(unVerifyProfilesReq.rejected, (state, action) => {
            state.error = 'Error occured'
            return state
        })

        builder.addCase('LOGOUT', () => initialState)
    }
})

export default ProfilesSlice.reducer